import { axiosApiInstance } from "../services/AxiosConfig";
import { fetchLanguages, detectLanguageSuccess } from "../reducers/laguagesReducer";
import { generateAddSegmentsAction, segmentsIsLoading } from "../reducers/segmentsReducer";
import axios from "axios";
import { Base64 } from "js-base64";
import { fileIsLoading, addTransUnits, downloadTranslatedFile } from "../reducers/uploadFileReducer";
import { validateSegment, validationLoading } from "../reducers/validationReducer";
import { getText } from "../helpers/heper";

const base_url = "https://api.textunited.com/OpenEditor/";
const old_base_url = "https://www.textunited.com/api/";

export const downloadFile = (translatedFile) => async (dispatch) => {
  dispatch(fileIsLoading());
  try {
    const options = {
      method: "POST",
      url: base_url + "/Po/revert",
      headers: {
        "Content-Type": "application/json",
      },

      data: {
        fileId: translatedFile.fileId,
        transUnits: translatedFile.transUnits,
      },
    };

    await axiosApiInstance
      .request(options)
      .then((response) => dispatch(downloadTranslatedFile(response.data)))
      .then((data) => getText(data));
  } catch (e) {
    console.log("ERROR in COMPLETE FILE");
  }
};
export const validationSegment = (segmentData) => async (dispatch) => {
  dispatch(validationLoading());
  try {
    const options = {
      method: "POST",
      url: base_url + "validate",
      headers: {
        "Content-Type": "application/json",
      },

      data: {
        referenceSegment: segmentData.SourceText,
        validatedSegment: segmentData.TargetText,
        segmentState: 200,
        maxLength: null,
      },
    };

    await axiosApiInstance
      .request(options)
      .then((response) => dispatch(validateSegment({ svr: response.data, segmentId: segmentData.segmentId })))
      .catch((error) => console.error(error.message));
  } catch (e) {
    console.log("ERROR", e);
  }
};

export const getLanguages = () => async (dispatch) => {
  try {
    const languages = await axiosApiInstance({
      method: "get",
      url: base_url + "/languages",
      headers: {
        "Content-Type": "application/json",
        //Authorization: basic,
      },
    });
    dispatch(fetchLanguages(languages.data));
  } catch (e) {
    console.log(e);
  }
};

export const getTranslation = (model) => async (dispatch) => {
  dispatch(segmentsIsLoading());
  let segments = Object.values(model.entities);
  try {
    const options = {
      method: "POST",
      url: base_url + "MachineTranslation",
      headers: {
        "Content-Type": "application/json",
      },

      data: {
        sourceLanguageId: model.sourceLanguageId,
        targetLanguageId: model.targetLanguageId,
        putTargetOnError: true,
        semgments: segments,
        engine: 0,
      },
    };

    await axiosApiInstance.request(options).then((response) => dispatch(generateAddSegmentsAction(response.data)));
  } catch (e) {
    console.log("EROOR in machine translation", e);
  }
};

export const getTransUnits = (file) => async (dispatch) => {
  dispatch(fileIsLoading());

  try {
    const options = {
      url: base_url + "/Po/convert",
      method: "post",
      // headers: {
      //   "Content-Type": "application/json",
      //   Authorization: `Bearer ${token}`,
      // },
      data: {
        projectId: null,
        base64File: Base64.encode(file),
        paragraphSegmentation: false,
        tags: ["string"],
        exclude: false,
        fileName: "file.po",
      },
    };

    axiosApiInstance.request(options).then((response) => dispatch(addTransUnits(response.data)));
  } catch (e) {
    console.log(e);
  }
};

export const langDetection = (text) => async (dispatch) => {
  try {
    const detectedLang = await axiosApiInstance({
      method: "post",
      url: base_url + "LanguageDetection",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        text: text,
      },
    });
    dispatch(detectLanguageSuccess(detectedLang.data));
  } catch (e) {
    console.log("ERROR in LANG DETECTION", e);
  }
};

export async function getToken() {
  const data = await axios.post("https://api.textunited.com/authentication/api/AnonymousToken");
  return data;
}
